/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.feature.store.rpc.FeatureStoreAppRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const getAllFeaturesRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.FeatureStoreAppRpc',
  rpcName: 'getAllFeatures',
  auth: 'app',
  fingerprint: 'JZreL4_Flzu03QZJ4ItUlZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getFeaturesWithLimitsAndDescriptionsRpc = {
  serviceName: 'com.hubspot.feature.store.rpc.FeatureStoreAppRpc',
  rpcName: 'getFeaturesWithLimitsAndDescriptions',
  auth: 'app',
  fingerprint: 'PgHItF4VP_nQq_oScfbRupwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};